import { isSolanaAddressFormatValid, validPlatformUrl } from "@/lib/buyValidation";

const configured = (name, value) => {
  if (typeof value !== "string") throw new Error(`Missing public configuration: ${name}`);
  return value.trim();
};

// Publishing the supplied mint does not change the site's launch status.
export const KBULL_TOKEN_ADDRESS = configured("REACT_APP_KBULL_TOKEN_ADDRESS", process.env.REACT_APP_KBULL_TOKEN_ADDRESS);
export const KBULL_ADDRESS_READY = isSolanaAddressFormatValid(KBULL_TOKEN_ADDRESS);
export const SOLSCAN_TOKEN_URL = `${configured("REACT_APP_SOLSCAN_BASE_URL", process.env.REACT_APP_SOLSCAN_BASE_URL).replace(/\/$/, "")}/token/${encodeURIComponent(KBULL_TOKEN_ADDRESS)}`;
const verification = configured("REACT_APP_KBULL_ADDRESS_VERIFIED", process.env.REACT_APP_KBULL_ADDRESS_VERIFIED);
if (!["true", "false"].includes(verification)) throw new Error("REACT_APP_KBULL_ADDRESS_VERIFIED must be true or false");
// This flag is set ONLY after the owner independently verifies the actual mint; never by syntax alone.
export const KBULL_ADDRESS_VERIFIED = KBULL_ADDRESS_READY && verification === "true";

const platform = (id, name, domains, configuredUrl, options = {}) => ({
  id,
  name,
  image: options.image === false ? null : `/assets/artwork/buy/${id}.webp`,
  url: validPlatformUrl(configuredUrl, domains),
  tokenSpecific: Boolean(options.tokenSpecific),
  actionLabel: options.actionLabel ?? "OPEN PLATFORM",
});

export const BUY_TRADING_PLATFORMS = [
  platform("pumpfun", "PUMP.FUN", ["pump.fun"], configured("REACT_APP_PUMPFUN_BUY_URL", process.env.REACT_APP_PUMPFUN_BUY_URL), { tokenSpecific: true }),
  platform("jupiter", "JUPITER", ["jup.ag"], configured("REACT_APP_JUPITER_BUY_URL", process.env.REACT_APP_JUPITER_BUY_URL)),
  platform("raydium", "RAYDIUM", ["raydium.io"], configured("REACT_APP_RAYDIUM_BUY_URL", process.env.REACT_APP_RAYDIUM_BUY_URL)),
  platform("orca", "ORCA", ["orca.so"], configured("REACT_APP_ORCA_BUY_URL", process.env.REACT_APP_ORCA_BUY_URL), { image: false }),
];

export const BUY_WALLET_PLATFORMS = [
  platform("phantom", "PHANTOM", ["phantom.app", "phantom.com"], configured("REACT_APP_PHANTOM_BUY_URL", process.env.REACT_APP_PHANTOM_BUY_URL)),
];

export const BUY_ANALYTICS_PLATFORMS = [
  platform("dexscreener", "DEXSCREENER", ["dexscreener.com"], configured("REACT_APP_DEXSCREENER_PAIR_URL", process.env.REACT_APP_DEXSCREENER_PAIR_URL), { image: false, tokenSpecific: true, actionLabel: "VIEW CHART" }),
];

export const HOME_PLATFORM_LINKS = [...BUY_TRADING_PLATFORMS, ...BUY_ANALYTICS_PLATFORMS];